import React from 'react';
import ReactDOM from 'react-dom';
import App from './Components/App';
import './Components/App.css';

ReactDOM.render(<App/>,document.querySelector('#root'));
